import React, { useContext, useEffect, useLayoutEffect, useState } from 'react';
import './index.less';
import anime from 'animejs';
import { LoginModalCtx } from '..';
import BgNewPath from './BgNewPath';
import { ArrowRight } from '@icon-park/react';
import Background from '../Background';
import { animated } from 'react-spring';
import { throttle } from 'lodash';

function getScale() {
    return Math.max(window.innerWidth / 1920, 1);
}
function getIndicateShow() {
    return window.innerWidth < 1920 && window.innerHeight < 1300
        ? true
        : window.innerHeight / window.innerWidth <= 1080 / 1920;
}

function Banner({ isHome }: { isHome: boolean }) {
    useLayoutEffect(() => {
        initTextLetter();
        setTimeout(() => {
            animateBannerText();
        }, 600);
    }, []);

    const { enterSystem } = useContext(LoginModalCtx);

    const [indicateArrowShow, setIndicateArrowShow] = useState(false);
    const [scale, setScale] = useState(getScale);
    useEffect(() => {
        const throttleScale = throttle(() => {
            setScale(getScale());
            setIndicateArrowShow(getIndicateShow());
        }, 100);
        window.addEventListener('resize', throttleScale);
        throttleScale();
        return () => window.removeEventListener('resize', throttleScale);
    }, []);

    return (
        <animated.div
            className="banner"
            style={{
                transform: `translate(0, -20px) scale(${scale})`,
                paddingBottom: `${270 + (scale - 1) * 9 * 130}px`,
            }}
        >
            <div className="title">
                <div className="title-logo">磁力万象</div>
                <div className="title-main">
                    <span>商业数据</span>
                    <span className="highlight">营销增长引擎</span>
                </div>
                <div className="title-en">Data-Driven Engine for Marketing Growth</div>
            </div>
            <div className="operate">
                <button className="start-btn button--wayra" onClick={enterSystem}>
                    <span className="text">立即体验</span>
                    <ArrowRight theme="filled" size="32" strokeWidth={4} fill="#ffffff" />
                </button>
                <div
                    className="indicate-arrow"
                    style={{
                        opacity: indicateArrowShow ? 1 : 0,
                        top: `200px`,
                    }}
                    onClick={() => {
                        window.scrollTo({
                            left: 0,
                            top: 820 * scale,
                            behavior: 'smooth',
                        });
                    }}
                >
                    <svg
                        width="40px"
                        height="100%"
                        viewBox="0 0 247 390"
                        version="1.1"
                        style={{
                            fillRule: 'evenodd',
                            clipRule: 'evenodd',
                            strokeLinecap: 'round',
                            strokeLinejoin: 'round',
                            strokeMiterlimit: 1.5,
                        }}
                    >
                        <path
                            id="wheel"
                            d="M123.359,79.775l0,72.843"
                            style={{
                                fill: 'none',
                                stroke: '#61cedf',
                                strokeWidth: 20,
                            }}
                        />
                        <path
                            id="mouse"
                            d="M236.717,123.359c0,-62.565 -50.794,-113.359 -113.358,-113.359c-62.565,0 -113.359,50.794 -113.359,113.359l0,143.237c0,62.565 50.794,113.359 113.359,113.359c62.564,0 113.358,-50.794 113.358,-113.359l0,-143.237Z"
                            style={{
                                fill: 'none',
                                stroke: '#2d76f6',
                                strokeWidth: 20,
                            }}
                        />
                    </svg>
                </div>
            </div>

            <div className="background-path">
                <BgNewPath />
            </div>
            <Background
                style={{
                    transition: 'all 0.6s',
                    opacity: isHome ? 1 : 0,
                }}
            />
        </animated.div>
    );
}

export default React.memo(Banner);

function initTextLetter() {
    const queryStrings = [
        '.title-logo',
        '.title-main > span',
        '.title-main > .highlight',
        '.title-en',
    ];
    queryStrings.forEach((str) => {
        const textWrapper = document.querySelector(str);
        //@ts-expect-error
        textWrapper.innerHTML = textWrapper.textContent.replace(
            /\S/g,
            "<span class='letter'>$&</span>",
        );
    });
}

function animateBannerText() {
    anime({
        targets: ['.title-logo .letter', '.title-main .letter', '.highlight .letter'],
        translateY: ['1.1em', 0],
        opacity: [0, 1],
        duration: 900,
        easing: 'easeOutExpo',
        delay: (el, i) => 30 * i,
    });
    anime({
        targets: '.title-en .letter',
        translateY: ['1.1em', 0],
        opacity: [0, 1],
        easing: 'easeOutExpo',
        duration: 500,
        delay: (el, i) => 200 + 20 * i,
    });
    anime({
        targets: '.banner .start-btn',
        translateY: [40, 0],
        opacity: [0, 1],
        translateZ: 0,
        easing: 'easeOutExpo',
        duration: 600,
        delay: 1600,
    });
}
